import {useContext, useEffect, useState} from 'react';

import {OrderListContext} from "../../context/OrderListContext";

import list from "api/order/list";

import {ITEM_PER_PAGE} from "config/_pagination";

// used as the Pagination key so it remounts (and its internal current page
// resets to 1) only when a param other than page changes - e.g. a filter,
// date range, search or status change, which all reset page to 1 themselves
function withoutPageParam(queryParams) {
    const params = new URLSearchParams(queryParams);

    params.delete('page');

    return params.toString();
}

// fetches the orders for the current queryParams and exposes everything
// needed to render either a table (desktop) or a list of cards (mobile)
function useOrderList() {
    const {queryParams, setQueryParams} = useContext(OrderListContext);

    const [retrieved, setRetrieved] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!queryParams) {
            return;
        }

        let cancelled = false;

        async function fetchOrders() {
            setLoading(true);

            const response = await list(queryParams);

            if (!cancelled) {
                const itemsPerPage = new URLSearchParams(queryParams).get('itemsPerPage') ?? ITEM_PER_PAGE;

                setRetrieved(response['hydra:member'] ?? []);
                setPageCount(Math.max(1, Math.ceil(response['hydra:totalItems'] / itemsPerPage)));
                setLoading(false);
            }
        }

        fetchOrders();

        return () => {
            cancelled = true;
        };
    }, [queryParams]);

    function handlePageChange(page) {
        setQueryParams((previousQueryParams) => {
            const params = new URLSearchParams(previousQueryParams);

            params.set('page', page);

            return params.toString();
        });
    }

    return {
        retrieved,
        loading,
        pageCount,
        handlePageChange,
        currentPage: Number(new URLSearchParams(queryParams).get('page')) || 1,
        paginationKey: withoutPageParam(queryParams)
    };
}

export default useOrderList;
